import Vue from 'vue'
import { IUser } from '../../model/user'
import { IStatement } from '../../model/statement'
import { StatementService } from '../../service/StatementService'
import statementStore from '../../store/statement/statement-store'
import convoStore from '../../store/convo/convo-store'
import userStore from '../../store/user/user-store'
import feedStore from '../../store/feed/feed-store'

export default class StatementComponent extends Vue {
  protected statementService: StatementService | null = null

  get statements () { return statementStore.state.statements }
  get statementForm () { return statementStore.state.statementForm }
  get statementSearchForm () { return statementStore.state.statementSearchForm }

  protected addStatement (): void {
    statementStore.dispatchAddStatement()
  }

  protected addFormTag (): void {
    statementStore.commitAddTagToForm({ })
  }

  protected removeFormTag(tag: string): void {
    statementStore.commitRemoveTagFromForm({ tag: tag })
  }

  protected addFormReference (): void {
    statementStore.commitAddReferenceToForm({ })
  }

  protected removeFormReference(index: number): void {
    statementStore.commitRemoveReferenceFromForm({ index: index })
  }

  protected findStatements (): void {
    statementStore.dispatchSetStatementQuery()
  }

  protected jybeStatement(statement: IStatement): void {
    statementStore.dispatchJybeStatement(statement)
  }

  protected unjybeStatement(statement: IStatement): void {
    statementStore.dispatchUnjybeStatement(statement)
  }

  protected considerStatement(statement: IStatement): void {
    statementStore.dispatchConsiderStatement(statement)
  }

  protected unconsiderStatement(statement: IStatement): void {
    statementStore.dispatchUnconsiderStatement(statement)
  }

  protected ignoreStatement(statement: IStatement): void {
    statementStore.dispatchIgnoreStatement(statement)
  }

  protected unignoreStatement(statement: IStatement): void {
    statementStore.dispatchUnignoreStatement(statement)
  }

  protected followUser(user: IUser): void {
    userStore.dispatchFollowUser(user)
  }

  protected unfollowUser(user: IUser): void {
    userStore.dispatchUnfollowUser(user)
  }

  protected addFormStatement(statement: IStatement): void {
    convoStore.dispatchAddFormStatement(statement)
  }

  protected viewStatements (): void {
    feedStore.dispatchViewStatements()
  }

  protected viewConvos (): void {
    feedStore.dispatchViewConvos()
  }

  protected newConvo (): void {
    feedStore.dispatchNewConvo()
  }
}
